// extracted by mini-css-extract-plugin
export default {"commentContainer":"Emotion_commentContainer__WP0rR","emotion":"Emotion_emotion__aYrX4"};